"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchAdapter;

var _dsCore = require("@irim/ds-core");

var _fetcher = _interopRequireDefault(require("../ability/fetcher"));

var _jsonp = _interopRequireDefault(require("../ability/jsonp"));

var _upload = _interopRequireDefault(require("../ability/upload"));

var _download = _interopRequireDefault(require("../ability/download"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// fetch middleware
// @author Pluto <huarse@gmail.com>
// @create 2020/01/05 18:10
const typeMapping = {
  ajax: _fetcher.default,
  fetcher: _fetcher.default,
  jsonp: _jsonp.default,
  upload: _upload.default,
  download: _download.default
};

async function fetchAdapter(ctx) {
  ctx.type = ctx.type || 'ajax';
  const fn = typeMapping[ctx.type] || typeMapping.ajax;

  if (typeof fn.init === 'function' && !fn.hasInit) {
    throw new Error("".concat(ctx.type, " \u672A\u521D\u59CB\u5316\uFF01"));
  }

  ctx.response = await fn(ctx.api, ctx);
  return await ctx.next();
}

fetchAdapter.init = function (name, config) {
  const fn = typeMapping[name];
  if (!fn) return _dsCore.logger.warn("".concat(name, " is not exist."));
  if (!fn.init) return _dsCore.logger.debug("".concat(name, " has no init method."));
  if (fn.hasInit) return _dsCore.logger.debug("".concat(name, " has been init."));
  return fn.init(config);
};

fetchAdapter.typeMapping = typeMapping;